import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();
//# sourceMappingURL=RouteHistory.js.map